import type { ReactNode } from 'react';

import type { ResourceColorName } from '../../../theme/tokens/resourcesColors';

export type ResourceSectionCardState = 'loading' | 'empty' | 'content';

export type ResourceSectionCardProps = {
  variant: ResourceColorName;
  title: string;
  count: number;
  isLoading: boolean;
  isEmpty: boolean;
  emptyLabel: string;
  children?: ReactNode;
  'data-testid'?: string;
};

export function useResourceSectionCard(props: ResourceSectionCardProps) {
  const state: ResourceSectionCardState = props.isLoading ? 'loading' : props.isEmpty ? 'empty' : 'content';

  return {
    state,
    countColor: props.count > 0 ? 'pending' as const : 'default' as const,
  };
}
